export default {
  translation: {
    common: {
      emailOrUsername: 'E-posta adresi veya Kullanıcı adı',
      invalidEmailOrUsername: 'Geçersiz e-posta adresi veya kullanıcı adı',
      invalidPassword: 'Hatalı Şifre',
      logInToPlanka: 'Giriş Yap',
      noInternetConnection: 'Internet bağlantısı yok',
      pageNotFound_title: 'Sayfa bulunamadı',
      password: 'Şifre',
      projectManagement: 'Proje Yönetimi',
      serverConnectionFailed: 'Sunucu bağlantı hatası',
      unknownError: 'Bilinmeyen Hata, daha sonra tekrar deneyin',
    },

    action: {
      logIn: 'Giriş Yap',
    },
  },
};
